import React from 'react';
import './Footer.css';

function Footer() {
  // Use the temple logo from assets instead of public folder
  const logoPath = process.env.PUBLIC_URL 
    ? `${process.env.PUBLIC_URL}/images/sri_venkateswara_logo.png`
    : '/images/sri_venkateswara_logo.png';

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <img 
              src={logoPath} 
              alt="GPR Grande Sri Lakshmi Venkateswara Temple Logo" 
              onError={(e) => { 
                e.target.style.display = 'none'; 
              }} 
            />
            <h3>GPR Grande Sri Lakshmi Venkateswara Temple Trust(R)</h3>
          </div>
          <p>
            A sacred place of devotion, spirituality, and tradition.
            Join us for daily sevas and special festivals.
          </p>
          <div className="social-icons">
            <a href="#" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
            <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="#" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#darshan">Darshan Booking</a></li>
            <li><a href="#sevas">Seva Services</a></li>
            <li><a href="#accommodation">Accommodation</a></li>
            <li><a href="#events">Events & Festivals</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Us</h4>
          <p><i className="fas fa-map-marker-alt"></i> Mathrushri Nilayam, 19, Terracon Doctors Enclave, Chandapura, Bengaluru, Bommasandra, Karnataka 560081</p>
          <p><i className="fas fa-phone"></i> +91 9XXXXXXXXX</p>
          <p><i className="fas fa-envelope"></i> info@srilakshmivenkateshwaratemple.org</p>
          <p><i className="fas fa-clock"></i> Mon-Sun: 6:00 AM - 9:00 PM</p>
          <p><i className="fas fa-file-alt"></i> Trust Registered: 02.08.2025</p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>
            © {new Date().getFullYear()} GPR Grande Sri Lakshmi Venkateswara Temple Trust(R). All rights reserved.
          </p>
          <div className="footer-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;